import _classCallCheck from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @class
 * @implements MiddlewareOptions
 * A class representing RedirectHandlerOptions
 */
export var RedirectHandlerOptions =
/**
 * @public
 * @constructor
 * To create an instance of RedirectHandlerOptions
 * @param {number} [maxRedirects = RedirectHandlerOptions.DEFAULT_MAX_REDIRECTS] - The max redirects value
 * @param {ShouldRedirect} [shouldRedirect = RedirectHandlerOptions.DEFAULT_SHOULD_RETRY] - The should redirect callback
 * @returns An instance of RedirectHandlerOptions
 */
function RedirectHandlerOptions() {
  var maxRedirects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RedirectHandlerOptions.DEFAULT_MAX_REDIRECTS;
  var shouldRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RedirectHandlerOptions.DEFAULT_SHOULD_RETRY;

  _classCallCheck(this, RedirectHandlerOptions);

  if (maxRedirects > RedirectHandlerOptions.MAX_MAX_REDIRECTS) {
    var error = new Error("MaxRedirects should not be more than ".concat(RedirectHandlerOptions.MAX_MAX_REDIRECTS));
    error.name = "MaxLimitExceeded";
    throw error;
  }

  if (maxRedirects < 0) {
    var _error = new Error("MaxRedirects should not be negative");

    _error.name = "MinExpectationNotMet";
    throw _error;
  }

  this.maxRedirects = maxRedirects;
  this.shouldRedirect = shouldRedirect;
};
/**
 * @private
 * @static
 * A member holding default max redirects value
 */

RedirectHandlerOptions.DEFAULT_MAX_REDIRECTS = 5;
/**
 * @private
 * @static
 * A member holding maximum max redirects value
 */

RedirectHandlerOptions.MAX_MAX_REDIRECTS = 20;
/**
 * @private
 * A member holding default shouldRedirect callback
 */

RedirectHandlerOptions.DEFAULT_SHOULD_RETRY = function () {
  return true;
};